import { render, staticRenderFns } from "./tabMaterialsMedicine.vue?vue&type=template&id=54cb5c0e&scoped=true&"
import script from "./tabMaterialsMedicine.vue?vue&type=script&lang=js&"
export * from "./tabMaterialsMedicine.vue?vue&type=script&lang=js&"
import style0 from "./tabMaterialsMedicine.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tabMaterialsMedicine.vue?vue&type=style&index=1&id=54cb5c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb5c0e",
  null
  
)

export default component.exports